import React from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios';
import DocumentMeta from 'react-document-meta';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faSearch, faPlus, faFilter, faChevronLeft } from '@fortawesome/free-solid-svg-icons'

import AppContext from '../../../AppContext.js';
import OffsetTop from '../../../components/offsetTop.js';

const localization = {
    ua: {
        title: 'Запланованi роботи',
        filter: {
            date: 'Дата'
        },
        noData: 'Данi вiдсутнi',
    },
    ru: {
        title: 'Запланированные работы',
        filter: {
            date: 'Дата'
        },
        noData: 'Нет данных',
    },
    en: {
        title: 'Planned works',
        filter: {
            date: 'Date'
        },
        noData: 'No data',
    },
}

class MechanicPlanning extends React.Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
		
		this.state = {
            isLoading: true,

            filterDate: null,

            rows: []
        }

        this.dateToInputFormat= this.dateToInputFormat.bind(this);
        this.dateToDatabaseFormat= this.dateToDatabaseFormat.bind(this);

        this.changeDate= this.changeDate.bind(this);
        this.datePrev = this.datePrev.bind(this);
        this.dateNext = this.dateNext.bind(this);
    }

    componentDidMount() {
        const {lang, setMenuExpandText} = this.context;
        setMenuExpandText(localization[lang].title);

        this.setState({filterDate: Date.now()}, () => {
            this.loadList();
        });
    }

    dateToInputFormat(date) {
        var d = new Date(date);
        var month = '' + (d.getMonth() + 1);
        var day = '' + d.getDate();
        var year = d.getFullYear();

        if (month.length < 2) 
            month = '0' + month;
            
        if (day.length < 2) 
            day = '0' + day;

        return [year, month, day].join('-');
    }

    dateToDatabaseFormat(date) {
        var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;

        return [day, month, year].join('.');
    }

    changeDate(event) {
        this.setState({filterDate: new Date(event.target.value).getTime()}, () => {
            this.loadList();
        });
    }

    datePrev() {
        this.setState({filterDate: this.state.filterDate - 86400000}, () => {
            this.loadList();
        });
    }

    dateNext() {
        this.setState({filterDate: this.state.filterDate + 86400000}, () => {
            this.loadList();
        });
    }

    loadList() {
        const {addNotification, removeNotification, token} = this.context;
        
        if (process.env.NODE_ENV === 'production') {
            var u = addNotification("Завантаження...");
            axios.post('/api/service/mechanic/planning/list', { token: token, date: this.dateToDatabaseFormat(this.state.filterDate) }).then((res) => {
                this.setState({rows: res.data.rows, isLoading: false});
            }).catch((error) => {
                addNotification(error.response.data, error.response.status);
            }).finally(function () {
                removeNotification(u);
            });
        } else {
            this.setState({
                isLoading: false,
                rows: [
                    {
                        item: 1,
                        start: "23.07.2020 8:00:00",
                        finish: "23.07.2020 8:15:00",
                        hours: 0.25,
                        description: "",
                        status: 1,
                        group: 1,
                    },
                    {
                        item: 2,
                        start: "23.07.2020 8:15:00",
                        finish: "23.07.2020 10:00:00",
                        hours: 1.75,
                        description: "ЗН <a href=\"https://sk.scania.ua/public/order/95681/tracker\">TR-1908790</a> вiд 22.10.2019<br/>Гелка С.В.<br/>WIELTON PC2, SUDPC200000045784, CE8222XT<br/><b>Діагностика (Несправність АБС причепа)</b>",
                        status: 201,
                        group: 2,
                    },
                    {
                        item: 3,
                        start: "23.07.2020 10:00:00",
                        finish: "23.07.2020 10:30:00",
                        hours: 0.5,
                        description: "",
                        status: 1,
                        group: 1,
                    },
                    {
                        item: 4,
                        start: "23.07.2020 10:30:00",
                        finish: "23.07.2020 12:15:00",
                        hours: 1.75,
                        description: "ЗН <a href=\"https://sk.scania.ua/public/order/95684/tracker\">CT-1908793</a> вiд 22.10.2019<br/>ОЛЛ ІНЖИНІРИНГ<br/>SCANIA G440A4X2NA, 5557630, AA0612EM<br/><b>R (R)</b>",
                        status: 201,
                        group: 2,
                    }
                ]
            });
        }
    }

    renderList() {
        const {lang} = this.context;

        if (this.state.rows.length === 0) {
            return (
                <div className="row">
                    <div className="col">
                        <div className="card agis-card">
                            <div className="row">
                                <div className="col" style={{display: "flex", alignItems: "center", height: "30px"}}>
                                    <div>
                                        <h6><b>{localization[lang].noData}</b></h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return this.state.rows.map((item, i) => {
                return (
                    <div className="row mb-2" key={"list_" + i}>
                        <div className="col">
                            <div className="card-agis pt-2 pb-2 noselect clickable" style={item.group == 1 ? {backgroundColor: "#eee", borderRadius: "15px"} : {borderRadius: "15px"}}>
                                <big><b>{item.start.split(" ")[1] + " - " + item.finish.split(" ")[1]}</b> <span className="text-success">({item.hours})</span></big>

                                <span dangerouslySetInnerHTML={{__html: item.description}} />
                            </div>
                        </div>
                    </div>
                );
            });
        }
    }

    render() {
        const {lang} = this.context;

        const meta = {
			title: localization[lang].title,
			description: localization[lang].title,
			meta: {
			  	charset: 'utf-8'
			}
        };

        if (this.state.isLoading) {
            return (
                <div>Loading...</div>
            );
        }

        return (
            <div>
                <DocumentMeta {...meta} />
                <OffsetTop submenu={false} />

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-10 offset-md-1">
                            <div className="container-fluid pl-0 pr-0">
                                
                                <div className="row mb-3">
                                    <div className="col d-flex justify-content-between">
                                        <button className="btn-agis-light-outline" style={{height: "36px", width: "36px", minWidth: "36px"}} onClick={this.datePrev}><FontAwesomeIcon icon={faChevronLeft}/></button>
                                        <input type="date" className="form-control form-control-sm ml-2 mr-2" style={{height: "36px", borderRadius: "10px"}} onChange={this.changeDate} value={this.dateToInputFormat(this.state.filterDate)}/>
                                        <button className="btn-agis-light-outline" style={{height: "36px", width: "36px", minWidth: "36px"}} onClick={this.dateNext}><FontAwesomeIcon icon={faChevronRight}/></button>
                                    </div>
                                </div>

                                {this.renderList()}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default MechanicPlanning;